import React, { useState, useEffect, useRef } from 'react';
import { useCountdown } from 'businessLogic/helperHooks.js';

const RemainingTimeCountDown = (props) => {
  const { start, time, stop, updateCountDown } = useCountdown({
    h: props.hours || 0,
    m: props.minutes || 0,
    s: props.seconds || 0,
    onCompleteCb: props.onCompleteCb,
  });

  useEffect(() => {
    stop();
    updateCountDown(props.hours || 0, props.minutes || 0, props.seconds || 0);
    start();
  }, [props.seconds, props.minutes, props.hours]);

  return <>{time.format('mm:ss')}</>;
};

export default RemainingTimeCountDown;
